<Header 
  full_report_url={props.meta.full_report_url}
  subtitle={props.meta.subtitle}
  title={props.meta.title}
  url={props.meta.url}
/>
<div className="slides_container">
  <SlideNav />
  <Slide01 />
  <Slide02 url={props.meta.url} />
  <Slide03 url={props.meta.url} />
  <Slide04 url={props.meta.url} />
  <Slide05 url={props.meta.url} />
  <Slide06 url={props.meta.url} />
  <Slide07 />
  <Slide08 url={props.meta.url} />
  <Slide09 url={props.meta.url} />
  <Slide10 />
</div>
<Footer full_report_url={props.meta.full_report_url} more_reports_url={props.meta.more_reports_url} />